import React from 'react';
import { Box, Typography } from '@mui/material';
import { useAutoTranslation } from 'src/hooks/useTranslate';
import {
  CLINRISK_DISCLAIMER,
  LICENCE_NOTICE,
  TRADEMARK_NOTICE
} from './qrisk3Text';

/**
 * ClinRisk's disclaimer, which the QRISK3-2017 licence requires to be held
 * together with any score and displayed with a displayed one (TGCLOUD-1911).
 * Rendered directly beneath every score: the result, each stored record and the
 * summary PDF. The disclaimer and the trademark line are shown as written,
 * never translated; the heading and TrakGene's licence notice are.
 */
export default function Qrisk3Disclaimer({ sx }) {
  const t = useAutoTranslation();
  return (
    <Box
      data-testid="qrisk3-disclaimer"
      sx={{
        mt: 2,
        p: 1.5,
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: '8px',
        ...sx
      }}
    >
      <Typography variant="subtitle2" gutterBottom>
        {t('Disclaimer from ClinRisk Ltd')}
      </Typography>
      <Typography variant="body2" sx={{ color: 'text.secondary' }} lang="en">
        {/* i18n-ignore: ClinRisk's disclaimer, required verbatim by the QRISK3-2017 licence */}
        {CLINRISK_DISCLAIMER}
      </Typography>
      <Typography
        variant="caption"
        sx={{ display: 'block', mt: 1, color: 'text.secondary' }}
      >
        {t(LICENCE_NOTICE)}
      </Typography>
      <Typography
        variant="caption"
        sx={{ display: 'block', color: 'text.secondary' }}
        lang="en"
      >
        {/* i18n-ignore: the trademark notice, as its holders word it */}
        {TRADEMARK_NOTICE}
      </Typography>
    </Box>
  );
}
